var _rect, _path, _g, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 185,
    viewBox: "0 0 221 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 75,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_4516_51331)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 44.3048C105.039 42.8015 110.247 42.7643 115.14 44.1978L201.676 69.5467C207.399 71.2232 207.437 79.3173 201.729 81.0469L115.378 107.214C110.337 108.742 104.95 108.702 99.9323 107.101L18.214 81.0202C12.618 79.2343 12.6564 71.3026 18.2695 69.5709L100.166 44.3048Z",
    fill: "#3D3D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4516_51331)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 73,
    rx: 26.5,
    ry: 2,
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.25 17.5H83.75C78.9171 17.5 75 21.4171 75 26.25V46.6667C75 51.4996 78.9171 55.4167 83.75 55.4167H136.25C141.083 55.4167 145 51.4996 145 46.6667V26.25C145 21.4171 141.083 17.5 136.25 17.5Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.833 35V32.0833C115.833 30.4733 114.527 29.1667 112.917 29.1667H107.083C105.473 29.1667 104.167 30.4733 104.167 32.0833V35C102.557 35 101.25 36.3067 101.25 37.9167V40.8333C101.25 42.4433 102.557 43.75 104.167 43.75H115.833C117.443 43.75 118.75 42.4433 118.75 40.8333V37.9167C118.75 36.3067 117.443 35 115.833 35Z",
    fill: "url(#paint1_linear_4516_51331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4167 35V32.0833C95.4167 30.4733 94.11 29.1667 92.5 29.1667H86.6667C85.0567 29.1667 83.75 30.4733 83.75 32.0833V35C82.14 35 80.8333 36.3067 80.8333 37.9167V40.8333C80.8333 42.4433 82.14 43.75 83.75 43.75H95.4167C97.0267 43.75 98.3333 42.4433 98.3333 40.8333V37.9167C98.3333 36.3067 97.0267 35 95.4167 35Z",
    fill: "url(#paint2_linear_4516_51331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.25 35V32.0833C136.25 30.4733 134.943 29.1667 133.333 29.1667H127.5C125.89 29.1667 124.583 30.4733 124.583 32.0833V35C122.973 35 121.667 36.3067 121.667 37.9167V40.8333C121.667 42.4433 122.973 43.75 124.583 43.75H136.25C137.86 43.75 139.167 42.4433 139.167 40.8333V37.9167C139.167 36.3067 137.86 35 136.25 35Z",
    fill: "url(#paint3_linear_4516_51331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4516_51331",
    x: 69,
    y: 57,
    width: 81,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_4516_51331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4516_51331",
    x1: 206,
    y1: 130,
    x2: 14,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4516_51331",
    x1: 110,
    y1: 29.1667,
    x2: 110,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B76F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4516_51331",
    x1: 89.5833,
    y1: 29.1667,
    x2: 89.5833,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B76F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4516_51331",
    x1: 130.417,
    y1: 29.1667,
    x2: 130.417,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B76F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDark);
export default __webpack_public_path__ + "static/media/illustration-dark.fea7bddd1479e491c014732f9ef1ca31.svg";
export { ForwardRef as ReactComponent };